import { AffectedIndividualsType } from "../../types/commonTypes/affectedIndividualsType";

export const initialAffectedIndividualsState: AffectedIndividualsType = {
    civility: "Monsieur",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    postalCode: "",
    cities: [],
    city: "",
  };